export const comments_4987556 = {"data":{"data":[],"links":{}}}